import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { desktopVW, mobileVW } from '../../styles/index'
import theme from '../../styles/theme'

import InputForm from './InputForm'

//-------------------*********************-----------------
//    Content for this is in Text page on contentful as we ran out of space
//-------------------*********************-----------------

export default function ContactForm({
  formPhoneNumber,
  formName,
  formMessage,
  formEmail,
  send,
  formFailedMessage,
  formSuccessMessage,
  contactSubTitle,
  sendingMessage,
}) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [message, setMessage] = useState('')
  const [containErrors, SetContainErrors] = useState(false)
  const [clicked, setClicked] = useState(false)
  const [sendButtonText, setSendButtonText] = useState(send)
  const [success, setSuccess] = useState({
    formSuccess: false,
    formFailure: false,
  })

  const handleContainerrors = (state) => {
    if (state) {
      SetContainErrors(true)
    }
    if (!state) {
      SetContainErrors(false)
    }
  }

  const reset = () => {
    setClicked(false)
    setFirstName('')
    setLastName('')
    setEmail('')
    setPassword('')
  }

  const softReset = () => {
    setClicked(false)
  }

  const emailJsParams = {
    user_id: 'user_7mp21yCwErQn66xoiOgGp',
    service_id: 'service_ctskb6p',
    template_id: 'template_uoh9c7h',
    template_params: {
      to_name: 'Stox',
      from_name: name,
      from_email: email,
      message: message,
      from_phoneNumber: phoneNumber,
    },
  }

  const emailJsHeaders = {
    'Content-type': 'application/json',
  }

  const emailJsOptions = {
    method: 'POST',
    headers: emailJsHeaders,
    body: JSON.stringify(emailJsParams),
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSendButtonText(sendingMessage)
    try {
      //  ***  Send an email to Stox.
      const everything = await fetch(
        'https://api.emailjs.com/api/v1.0/email/send',
        emailJsOptions,
      )
      if (everything.ok) {
        setSuccess({ formSuccess: true })
        setClicked(false)
        setName('')
        setEmail('')
        setPhoneNumber('')
        setMessage('')
        setSendButtonText(send)
      } else {
        setSuccess({ formFailure: true })
        setSendButtonText(send)
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      <Wrapper
        onSubmit={(e) => {
          handleSubmit(e)
        }}
      >
        <Title>Contact us</Title>
        <ContactMessage>
          <SubTitle> {contactSubTitle}</SubTitle>
        </ContactMessage>
        <FormWrapper>
          <InputForm
            inputName='form-name'
            inputType='hidden'
            inputValue='contact'
            setContainErrors={handleContainerrors}
          />
          <InputForm
            inputName='bot-field'
            inputType='hidden'
            setContainErrors={handleContainerrors}
          />

          <InputForm
            inputValue={name}
            inputSetValue={setName}
            inputName='name'
            inputType='text'
            required={true}
            onChangecallback={(e) => setName(e.target.value)}
            placeholder={formName}
            validation={'onlyLetters'}
            setContainErrors={handleContainerrors}
          />

          <InputForm
            inputValue={email}
            inputSetValue={setEmail}
            inputName='email'
            inputType='text'
            required={true}
            onChangecallback={(e) => setEmail(e.target.value)}
            placeholder={formEmail}
            validation={'onlyEmail'}
            setContainErrors={handleContainerrors}
          />
          <InputForm
            inputValue={phoneNumber}
            inputSetValue={setPhoneNumber}
            inputName='phone number'
            inputType='numeric'
            required={true}
            onChangecallback={(e) => setPhoneNumber(e.target.value)}
            placeholder={formPhoneNumber}
            validation={'onlyNumbers'}
            setContainErrors={handleContainerrors}
          />

          <TextArea
            name='message'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={formMessage}
          ></TextArea>
          <SendButton type='submit'>{sendButtonText}</SendButton>
        </FormWrapper>
        {success.formSuccess ? (
          <FormMessageSuccess>{formSuccessMessage}</FormMessageSuccess>
        ) : null}
        {success.formFailure ? (
          <FormMessageFail>{formFailedMessage}</FormMessageFail>
        ) : null}
      </Wrapper>
    </>
  )
}

const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  position: relative;
  top: ${mobileVW(8)};

  @media (min-width: ${theme.breakPoints.desktop}) {
    top: 0;
    width: ${desktopVW(466, 1440)};
  }
`
const FormWrapper = styled.div`
  font-family: ${theme.fontFamily.normal};
  display: flex;
  flex-direction: column;
`

const Title = styled.p`
  display: flex;
  font-size: 6.6667vw;
  margin-bottom: ${mobileVW(10)};
  color: ${theme.colors.blue};
  @media (min-width: ${theme.breakPoints.desktop}) {
    margin: 0;
    font-size: ${theme.fontSize.d35};
  }
`
const ContactMessage = styled.div`
  display: flex;
  margin-bottom: ${mobileVW(10)};
  @media (min-width: ${theme.breakPoints.desktop}) {
    margin: 0;
    font-size: ${theme.fontSize.d14};
  }
`
const SubTitle = styled.p`
  font-size: ${theme.fontSize.m23};
  @media (min-width: ${theme.breakPoints.desktop}) {
    font-size: ${theme.fontSize.d15};
    padding-bottom: ${desktopVW(10, 1440)};
    padding-top: ${desktopVW(10, 1440)};
  }
`

const SendButton = styled.button`
  font-size: ${theme.fontSize.m30};
  display: flex;
  justify-content: center;
  padding: ${mobileVW(20)} ${mobileVW(20)};
  width: 100%;
  color: ${theme.colors.white};
  background-color: ${theme.colors.blue};
  margin-top: ${mobileVW(20)};
  cursor: pointer;
  transition: all 0.2s ease;
  @media (min-width: ${theme.breakPoints.desktop}) {
    margin-top: ${desktopVW(10, 1440)};
    width: 100%;
    font-size: ${theme.fontSize.d15};
    padding: ${desktopVW(20, 1440)} ${desktopVW(20, 1440)};
  }
  &:hover {
    background-color: #162950;
  }
`

const TextArea = styled.textarea`
  resize: none;
  height: ${mobileVW(140)};
  border: 1px solid #ececec;
  font-family: inherit !important;
  font-size: ${mobileVW(12)}!important;
  padding-left: ${mobileVW(30)};

  margin: ${mobileVW(5)} 0;
  padding-top: ${mobileVW(20)};

  @media (min-width: ${theme.breakPoints.desktop}) {
    margin: ${desktopVW(10, 1440)} 0;
    padding-top: ${desktopVW(20, 1440)};
    padding-left: ${desktopVW(30, 1440)};
    height: ${desktopVW(140, 1440)};
    font-size: ${desktopVW(12, 1440)}!important;
  }

  ::placeholder {
    color: ${theme.colors.darkGrey};

    @media (min-width: ${theme.breakPoints.desktop}) {
      color: ${theme.colors.darkGrey};
    }
  }
`

const FormMessageSuccess = styled.p`
  font-size: ${theme.fontSize.m23};
  color: ${theme.colors.green};
  padding-bottom: ${mobileVW(10)};
  padding-top: ${mobileVW(10)};
  @media (min-width: ${theme.breakPoints.desktop}) {
    font-size: ${theme.fontSize.d15};
    padding-bottom: ${desktopVW(10, 1440)};
    padding-top: ${desktopVW(10, 1440)};
  }
`
const FormMessageFail = styled.p`
  font-size: ${theme.fontSize.m23};
  color: ${theme.colors.daily};
  padding-bottom: ${mobileVW(10)};
  padding-top: ${mobileVW(10)};
  @media (min-width: ${theme.breakPoints.desktop}) {
    font-size: ${theme.fontSize.d15};
    padding-bottom: ${desktopVW(10, 1440)};
    padding-top: ${desktopVW(10, 1440)};
  }
`
